import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

const Hr = styled.hr`
  width: 100%;
  background-color: ${themeGet('colors.black.10')};
  margin: 0 auto;
`;

export default Hr;
